import { Magazine } from "../interfaces/magazine.interface";

export const magazines: Magazine[] = [
  // Latest Issues
  {
    slug: "autumn-realm-en",
    title: "English | GD Magazine: Autumn 2026",
    language: "en",
    coverImage: "/iceholidays-assets/images/magazine/autumn_en_2026.png",
    embedUrl: "https://ebook.gd.my/mag-en",
    publishedAt: "2026-07-31",
    isLatest: true,
  },
  {
    slug: "autumn-realm-cn",
    title: "Chinese | GD Magazine: Autumn 2026",
    language: "cn",
    coverImage: "/iceholidays-assets/images/magazine/autumn_cn_2026.png",
    embedUrl: "https://ebook.gd.my/mag-cn/",
    publishedAt: "2026-07-31",
    isLatest: true,
  },
];
